import React from 'react';

import { faPencil, faTrash } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useDialogs } from '../../../hooks';
import AppointmentInfo from './AppointmentInfo';

const AppointmentDialog = () => {
  const {
    activeAppointment,
    showAppointmentDialog: isOpen,
    handleCloseAppointmentDialog: onClose,
    handleDeleteAppointmentClick: onDeleteClick,
    handleEditAppointmentClick: onEditClick,
  } = useDialogs();

  if (!activeAppointment) return null;

  const handleOpenChange = (open) => {
    if (!open) onClose();
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={isOpen}>
      <DialogContent className="space-y-2">
        <DialogHeader>
          <DialogTitle>{activeAppointment.title}</DialogTitle>
        </DialogHeader>

        <AppointmentInfo activeAppointment={activeAppointment} />

        <DialogFooter>
          <Button onClick={() => onDeleteClick(activeAppointment)} variant="outline">
            <FontAwesomeIcon icon={faTrash} />
            Delete
          </Button>

          <Button onClick={() => onEditClick(activeAppointment)} variant="outline">
            <FontAwesomeIcon icon={faPencil} />
            Edit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AppointmentDialog;
